import { ValueCell } from "../types";
import { GroupListData, PracticeFunnelDataRow, RoleCountItem, SaleFunnelDataRow } from "../services";
import { EventStatsItem } from "../forms/filters/stats";
import { eventTypeNames } from "../constants/events";

export const eventHeadings = {
  account_opening: "Открытие счета",
  consultation: "Консультация",
  invoice_question: "Вопрос о счёте",
  practice: "Практика",
  registration: "Регистрация",
  subsequent_deposit: "Последующее пополнение",
};

export const practiceHeadings = {
  practice_1: "Практика 1",
  practice_2: "Практика 2",
  practice_3: "Практика 3",
  practice_4: "Практика 4",
  practice_5: "Практика 5",
  practice_6: "Практика 6",
  practice_7: "Практика 7",
  practice_8: "Практика 8",
  practice_9: "Практика 9",
  practice_10: "Практика 10",
};

export const keyList = [
  "registration",
  "consultation",
  "invoice_question",
  "practice",
  "account_opening",
  "subsequent_deposit",
];


export const sortGroupsHierarchy = (groups: GroupListData[]): GroupListData[] => {
  const groupMap = new Map<number, GroupListData>();
  const childrenMap = new Map<number | null, GroupListData[]>();

  // Заполняем мапу групп и дочерних групп
  groups.forEach((group) => {
    groupMap.set(group.id, group);
    const parentId = group.parent_group_id ?? null;
    if (!childrenMap.has(parentId)) {
      childrenMap.set(parentId, []);
    }
    childrenMap.get(parentId)!.push(group);
  });

  // Рекурсивная функция для построения списка и вычисления hierarchy_level
  const buildHierarchy = (
    parentId: number | null,
    level: number = 0
  ): GroupListData[] => {
    const result: GroupListData[] = [];
    (childrenMap.get(parentId) || []).forEach((group) => {
      result.push({ ...group, hierarchy_level: level }); // Устанавливаем уровень
      result.push(...buildHierarchy(group.id, level + 1)); // Добавляем дочерние группы
    });
    return result;
  };

  return buildHierarchy(null); // Начинаем с корневых элементов (где parent_group_id = null, 0, undefined)
};

export function getSortedTypeIds(items: EventStatsItem[]): number[] {
  return items
    .sort((a, b) => a.sort_index - b.sort_index) // Сортируем по возрастанию sort_index
    .map(item => item.type_id); // Преобразуем в массив type_id
}

export function createEventStatsItems(typeIds: number[]): EventStatsItem[] {
  return typeIds.map((type_id, index) => ({
    type_id,
    sort_index: index // Начинаем нумерацию с 0
  }));
}

export function extractEventId (event_key: string): number | undefined {
  const num = Number(event_key.replace("event_", ""));
  return isNaN(num) ? undefined : num;
}

export function getEventNameById (id: number): string {
  return eventTypeNames.find(item => item.id === id)?.name || `Событие, тип ${id}`
}

export function generateCellsFromEventData (data: Record<string, number>): ValueCell[] {
  const cells: ValueCell[] = [];
  for (let key in data) {
    const heading = getEventNameById(extractEventId(key) || 0);
    cells.push({
      heading,
      type_id: extractEventId(key) || 0,
      value: data[key]
    })
  }
  return cells;
}

export function sortByIndex(items: EventStatsItem[]): EventStatsItem[] {
  return [...items].sort((a, b) => a.sort_index - b.sort_index);
}
